import get from 'lodash/get';
import { hasRole } from '../utils/has-role';
import { APPLICATIONS } from '../app-config';
import { WHITELISTED_REDIRECT_DOMAINS, REDIRECT_STORAGE_KEY } from './';
import { oktaWidgetInstance } from '../components/OktaWidget/okta-widget-wrapper';
import { ROUTES } from '../navigation/router';

export async function revokeTokenAndRedirect(redirectURL) {
  const accessToken = await oktaWidgetInstance.authClient.tokenManager.get('accessToken');
  if (accessToken) {
    await oktaWidgetInstance.authClient.token.revoke(accessToken);
  }
  await oktaWidgetInstance.authClient.tokenManager.clear();

  window.location = redirectURL;
}

export async function resetOkta() {
  await attemptCloseOktaSession();
  await oktaWidgetInstance.authClient.tokenManager.clear();
  localStorage.clear();
  sessionStorage.clear();
  await revokeTokenAndRedirect(ROUTES.ROOT);
}

async function attemptCloseOktaSession() {
  try {
    await oktaWidgetInstance.authClient.session.close();
  } catch (error) {}
}

export function getAppsFromAccessToken(accessToken) {
  const roles = get(accessToken, ['claims', 'sundial_roles'], get(accessToken, ['accessToken', 'sundial_roles'], []));

  return APPLICATIONS.filter((app) => roles.some((role) => hasRole(app.roles, role.split(':')[1])));
}

export function setOrRemoveRedirectUrl(redirect) {
  if (redirect) {
    const redirectUrl = new URL(redirect);
    // Only allow redirects to Tempus domains.
    if (WHITELISTED_REDIRECT_DOMAINS.some((suffix) => redirectUrl.hostname.endsWith(suffix))) {
      window.sessionStorage.setItem(REDIRECT_STORAGE_KEY, redirect);
    }
  } else {
    // Clear if no redirect
    window.sessionStorage.removeItem(REDIRECT_STORAGE_KEY);
  }
}
